




























































import AlgoliaSearchAutocomplete from '@algolia-search/components/organisms/SearchAutocomplete/AlgoliaSearchAutocomplete.vue';
import {
  computed,
  defineComponent,
  onMounted,
  useRoute
} from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import VaimoIconSVG from 'atoms/VaimoIconSVG.vue';
import VaimoTopNavigation from 'organisms/header/VaimoTopNavigation.vue';
import { storeToRefs } from 'pinia';

import { useCart } from '~/composables';
import VaimoLogo from '~/diptyqueTheme/components/atoms/VaimoLogo.vue';
import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import { useMegaMenuMobileStore } from '~/diptyqueTheme/stores/megaMenuMobile';

export default defineComponent({
  name: 'VaimoHeader',
  components: {
    SfButton,
    VaimoTopNavigation,
    VaimoLogo,
    AlgoliaSearchAutocomplete,
    VaimoIconSVG
  },
  props: {
    cartProductsQuantity: {
      type: Number,
      default: 0
    },
    transparentHeader: {
      type: Boolean,
      default: false
    }
  },
  emits: ['account-toggle'],
  setup() {
    const route = useRoute();
    const megaMenuMobileStore = useMegaMenuMobileStore();
    const { isDesktopMenuOpen } = storeToRefs(megaMenuMobileStore);

    const { loadTotalQty: loadCartTotalQty } = useCart();
    const { isDesktop } = useScreenSize();

    const isCheckout = computed(() => {
      const checkout = route.value.path.includes('checkout');
      const success = route.value.path.includes('checkout/thank-you');
      return checkout && !success;
    });

    onMounted(async () => {
      if (isDesktop && !route.value.path.includes('checkout')) {
        await loadCartTotalQty();
      }
    });

    return {
      isCheckout,
      isDesktopMenuOpen
    };
  }
});
